<template>
  <div :class="tableHeader()">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { provide } from 'vue';
import { tableHeader } from '@carvia/theme/lib/cva/grid';
import { sortableTableKey, type SortDirection } from './sortable-table';

const sortColumn = defineModel<string>('sortColumn', { required: true });
const sortDirection = defineModel<SortDirection>('sortDirection', { required: true });

provide(sortableTableKey, { sortColumn, sortDirection });
</script>
